import { Theme } from '@mui/material/styles';

export function getCalendarDayStyles(
    highlightStyle: { status?: string } | undefined,
    theme: Theme,
) {
    if (highlightStyle?.status === 'mixed') {
        return {
            background: `linear-gradient(45deg,
            ${theme.palette.action.selected} 50%,
            ${theme.palette.warning.main} 50%)`,
            color: theme.palette.text.primary,
            '&.Mui-selected': {
                background: `linear-gradient(45deg,
                ${theme.palette.primary.main} 50%,
                ${theme.palette.warning.dark} 50%)`,
                color: theme.palette.primary.contrastText,
            },
        };
    }

    if (highlightStyle?.status === 'warning') {
        return {
            backgroundColor: theme.palette.warning.main,
            color: theme.palette.warning.contrastText,
            '&:hover': { backgroundColor: theme.palette.warning.dark },
            '&.Mui-selected': { backgroundColor: theme.palette.warning.dark },
        };
    }

    if (highlightStyle?.status === 'available') {
        return {
            backgroundColor: theme.palette.action.selected,
            '&:hover': { backgroundColor: theme.palette.action.hover },
            '&.Mui-selected': {
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText,
            },
        };
    }

    return {};
}

export default {
    getCalendarDayStyles,
};
